import React from "react";
import { ResumeStyles } from "./resume.styles";

const Resume = () => {
  return (
    <ResumeStyles>
      <div>
        <div>
          Мы&nbsp;продолжаем работать над определителем и&nbsp;будем рады вашим
          замечаниям, вопросам и&nbsp;ссылкам на&nbsp;материалы.
          <br />
          Вы&nbsp;можете их&nbsp;прислать на&nbsp;почту{" "}
          <a href="mailto:biblioteka@nekrasovka.ru">biblioteka@nekrasovka.ru</a>
          .
        </div>
        <div>
          Определитель создан специалистами отдела редких изданий
          и&nbsp;коллекций библиотеки имени Н.&nbsp;А.&nbsp;Некрасова
          на&nbsp;основе наших редких книг и&nbsp;коллекции «Декоративная
          бумага», а&nbsp;также&nbsp;фондов:
          <br />
          —&nbsp;Научной библиотеки МГУ имени М.&nbsp;В.&nbsp;Ломоносова,
          <br />
          —&nbsp;Центральной универсальной научной библиотеки
          Ивановской&nbsp;области,
          <br />
          —&nbsp;библиотеки Московского педагогического государственного
          университета,
          <br />
          —&nbsp;Всероссийской государственной библиотеки иностранной литературы
          имени&nbsp;М.&nbsp;И.&nbsp;Рудомино,
          <br />
          —&nbsp;Российской государственной библиотеки,
          <br />
          —&nbsp;Государственной публичной научно-технической библиотеки
          Сибирского отделения&nbsp;РАН,
          <br />
          —&nbsp;Национальной библиотеки Республики Саха (Якутия),
          <br />
          —&nbsp;Донской государственной публичной библиотеки,
          <br />
          —&nbsp;коллекции декоративной бумаги Феликса&nbsp;Хюбеля
          (Deutsche&nbsp;Museum&nbsp;Digital),
          <br />
          —&nbsp;Научной библиотеки Исследовательского института Гетти
          (Getty&nbsp;Research&nbsp;Institute).
        </div>
        <div>
          Благодарим за&nbsp;помощь и&nbsp;вдохновение участников круглого стола
          и&nbsp;группу «Декоративная&nbsp;бумага в&nbsp;книжном переплёте»:
          Е.&nbsp;В.&nbsp;Белозёрову, М.&nbsp;Б.&nbsp;Золотову,
          Т.&nbsp;Г.&nbsp;Зудину, Л.&nbsp;В.&nbsp;Камбулову,
          Т.&nbsp;В.&nbsp;Кульматову, А.&nbsp;И.&nbsp;Маркову,
          А.&nbsp;Б.&nbsp;Мелех, Е.&nbsp;В.&nbsp;Мымрину,
          Е.&nbsp;С.&nbsp;Неботову, О.&nbsp;Б.&nbsp;Пономаренко,
          Н.&nbsp;Б.&nbsp;Субботину, В.&nbsp;А.&nbsp;Толстову,
          К.&nbsp;П.&nbsp;Яркову.
          <br />
          <br />
          Иллюстративный ряд определителя существенно дополнен образцами
          из&nbsp;фонда отдела редких книг и&nbsp;рукописей Научной библиотеки
          МГУ имени М.&nbsp;В.&nbsp;Ломоносова благодаря деятельному участию
          в&nbsp;проекте А.&nbsp;Л.&nbsp;Лифшица
          и&nbsp;В.&nbsp;Л.&nbsp;Мотылёвой.
          <br />
          <br />
          Куратор проекта: Екатерина Коршунова, главный библиотекарь отдела
          редких изданий и&nbsp;коллекций библиотеки
          им.&nbsp;Н.&nbsp;А.&nbsp;Некрасова.
          <br />
          Автор концепции: Анна Зайцева, независимый исследователь.
        </div>
      </div>
    </ResumeStyles>
  );
};

export default Resume;
